export default "__VITE_ASSET__BkOuUW____"